export default __webpack_public_path__ + "static/media/sendIcon.4d607235.svg";